const SESSION_KEY = "pep-affiliate-session-token";

export function saveAffiliateSessionToken(token: string): void {
  localStorage.setItem(SESSION_KEY, token.trim());
}

export function getAffiliateSessionToken(): string | null {
  return localStorage.getItem(SESSION_KEY);
}

export function clearAffiliateSessionToken(): void {
  localStorage.removeItem(SESSION_KEY);
}

function authHeaders(): Record<string, string> {
  const token = getAffiliateSessionToken();
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}

export function affiliateAuthHeaders(): Record<string, string> {
  return {
    "Content-Type": "application/json",
    ...authHeaders(),
  };
}

export function affiliateAuthHeadersOnly(): Record<string, string> {
  return authHeaders();
}
